/**
 * Supply (BLU-1268): the look of each mode's cell in a colour x size grid,
 * shared by the catalog picker's grid and the Base garments Supply view (the
 * marks themselves live in `components/SupplyBadge.tsx`).
 */
import type { StockMode } from '@threadheads/shared';

/**
 * The look of a Supply cell in a colour x size grid (border style, fill,
 * text). The caller adds geometry and focus; a pressable cell adds
 * `SUPPLY_CELL_HOVER` (`SUPPLY_CELL_LOOK` is both), a read-only one does not.
 */
export const SUPPLY_CELL_STATIC: Record<StockMode, string> = {
  just_in_time: 'border-dashed border-threadheads-purple bg-primary/5 text-primary-strong',
  stocked: 'border-solid border-emerald-600 bg-emerald-50 text-emerald-800',
  managed_elsewhere: 'border-dotted border-slate-500 bg-slate-50 text-slate-700',
};
export const SUPPLY_CELL_HOVER: Record<StockMode, string> = {
  just_in_time: 'hover:bg-primary/10',
  stocked: 'hover:bg-emerald-100',
  managed_elsewhere: 'hover:bg-slate-100',
};
export const SUPPLY_CELL_LOOK: Record<StockMode, string> = {
  just_in_time: `${SUPPLY_CELL_STATIC.just_in_time} ${SUPPLY_CELL_HOVER.just_in_time}`,
  stocked: `${SUPPLY_CELL_STATIC.stocked} ${SUPPLY_CELL_HOVER.stocked}`,
  managed_elsewhere: `${SUPPLY_CELL_STATIC.managed_elsewhere} ${SUPPLY_CELL_HOVER.managed_elsewhere}`,
};
